<template>
    <div class="card">
        <div class="card-image" v-if="$slots.image">
            <slot name="image"></slot>
        </div>
        <div class="card-header" v-if="$slots.header">
            <slot name="header"></slot>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
        <div class="card-footer" v-if="$slots.footer">
            <hr>
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'card'
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/Card.vue